import { FC, useState, useEffect } from "react";
import StaticImageUploader from "./StaticImageUploader";
import {
  SlidingImgUploaderSection,
  SlidingImgList,
  SlidingImgItem,
  Count,
  ImgPlaceHolder,
  FormSection,
} from "./StyledPromotions";
import SliderImgUploader from "./SliderImgUploader/SliderImgUploader";
import {
  setDesktopSliderImgDetails,
  setMobileSliderImgDetails,
} from "../../features/promotions";
import { useDispatch } from "react-redux";
import { toggleLoader } from "../../features/loader";

const imagesList = [
  {
    imgUrl: "",
    position: 1,
    isSelected: true,
  },
  {
    imgUrl: "",
    position: 2,
    isSelected: false,
  },
  {
    imgUrl: "",
    position: 3,
    isSelected: false,
  },
  {
    imgUrl: "",
    position: 4,
    isSelected: false,
  },
  {
    imgUrl: "",
    position: 5,
    isSelected: false,
  },
  {
    imgUrl: "",
    position: 6,
    isSelected: false,
  },
];

interface SlidingImgProps {
  slidingImgs: any;
}

const SlidingImgUploader: FC<SlidingImgProps> = (props) => {
  const { slidingImgs } = props;
  const dispatch = useDispatch();
  // console.log(slidingImgs,"SlidingImgUploader")
  const [images, setImgsList] = useState(imagesList);
  const [activeSlidingObj, setActiveSlidingObj] = useState({});

  useEffect(() => {
    if (slidingImgs.length > 0) {
      let updatedSlidingList = slidingImgs.map((imgObj, index) => {
        let updateObj = {
          ...imgObj,
          isSelected: index === 0,
          position: index + 1,
        };
        if (index === 0) {
          setActiveSlidingObj(updateObj);
        }
        return updateObj;
      });
      setImgsList(updatedSlidingList);
    }
  }, [slidingImgs]);

  // console.log(images)
  const toggleSlidingItems = (position: number) => {
    setImgsList(
      images.map((imgObj: any) => {
        let updatedObj = {};
        if (imgObj.position === position) {
        //   console.log(imgObj);
          dispatch(toggleLoader({
            isLoading:true
          }))
          const Mobparts = imgObj?.promotionMobileBannerImages[0]?.split("/");
          const MobfileName = Mobparts[Mobparts.length - 1];
          const Webparts = imgObj?.promotionWebBannerImages[0]?.split("/");
          const WebfileName = Webparts[Webparts.length - 1];
          dispatch(
            setDesktopSliderImgDetails({
              fileName: WebfileName,
              imgUrl: imgObj?.promotionWebBannerImages[0],
            })
          );
          dispatch(
            setMobileSliderImgDetails({
              fileName: MobfileName,
              imgUrl: imgObj?.promotionMobileBannerImages[0],
            })
          );

          updatedObj["promotionMobileBannerImages"] =
            imgObj?.promotionMobileBannerImages;
          updatedObj["promotionWebBannerImages"] =
            imgObj?.promotionWebBannerImages;
          updatedObj["isSelected"] = true;
          updatedObj["promotionBannerUrl"] = imgObj?.promotionBannerUrl;
          updatedObj["promotionEndDate"] = imgObj?.promotionEndDate;
          updatedObj["promotionStartDate"] = imgObj?.promotionStartDate;
          updatedObj["promotionId"] = imgObj?.promotionId;
          updatedObj["isActive"] = imgObj?.isActive;
          updatedObj["bannerNo"] = imgObj?.bannerNo;
          updatedObj["promotionPage"] = imgObj?.promotionPage;

          setActiveSlidingObj(updatedObj);
        }

        return {
          ...imgObj,
          isSelected: imgObj.position === position,
        };
      })
    );
  };

  let imagesListView = images.map((imgObj, index) => {
    // console.log(imgObj)
    return (
      <SlidingImgItem
        onClick={() => {
          toggleSlidingItems(imgObj.position);
        }}
        isSelected={imgObj.isSelected}
      >
        <Count>{index + 1}</Count>
        <ImgPlaceHolder />
      </SlidingImgItem>
    );
  });

  // console.log(activeSlidingObj,"activeSlidingObj")

  return (
    <SlidingImgUploaderSection>
      <SlidingImgList>{imagesListView}</SlidingImgList>
      <FormSection>
        {/* <StaticImageUploader details={activeSlidingObj} bannerRedirectionUrl={""} /> */}
        <SliderImgUploader
          details={activeSlidingObj}
          bannerRedirectionUrl={""}
        />
      </FormSection>
    </SlidingImgUploaderSection>
  );
};

export default SlidingImgUploader;
